<template>
    <div>
        <div style="background: #4fac47;" class="hidden lg:block" v-if="showMessage">
            <div class="max-w-7xl mx-auto py-2 px-3 sm:px-6 lg:px-8">
                <div class="flex items-center justify-center flex-wrap">
                    <div class="w-0 flex-1 flex items-center justify-center">
                        <svg class="h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none"
                            viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z" />
                        </svg>
                        <p class="ml-2 font-medium text-white truncate">
                            Prices may increase due to currency devaluation without any prior notice.
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <Header v-if="isMobileApp"></Header>
        <transition name="loading">
            <div class="loading" v-if="loading">
                <div class="spinner"></div>
            </div>
        </transition>
        <div :style="$route.name !== 'Register' ? 'min-height: 100vh;' : ''">
            <transition>
                <router-view></router-view>
            </transition>
        </div>
        <Footer v-if="isMobileApp"></Footer>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "App",
    data() {
        return {
            showMessage: window.Telemart.showMessage
        }
    },
    computed: {
        ...mapState({
            loading: 'loading',
            responsive: 'responsive'
        }),
        isMobileApp() {
            const urlParams = new URLSearchParams(window.location.search);
            const shouldHide = urlParams.has('app') && urlParams.get('app') === '1' ? false : true
            return shouldHide
        }
    },
    components: {
        Header: () => import('./components/Header'),
        Footer: () => import('./components/Footer')
    },
    mounted() {
        this.onResize();
        window.addEventListener('resize', this.onResize, { passive: true });
    },
    beforeDestroy() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('resize', this.onResize, { passive: true });
        }
    },
    methods: {
        onResize() {
            (window.innerWidth < 1000) ?
                this.$store.commit('SET_RESPONSIVE', true) :
                this.$store.commit('SET_RESPONSIVE', false);
        },
    }

};
</script>

<style scoped>
.loading-enter-active,
.loading-leave-active {
    transition: opacity .5s
}

.loading-enter,
.loading-leave-to {
    opacity: 0
}

.loading {
    display: flex;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    justify-content: center;
    align-items: center;
    z-index: 4000;
    background-color: rgba(0, 0, 0, 0.1);
}

.spinner {
    border: 16px solid #f3f3f3;
    /* Light grey */
    border-top: 16px solid #3498db;
    /* Blue */
    border-radius: 50%;
    width: 60px;
    height: 60px;
    animation: spin 2s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>
